











































import Vue from 'vue'
import SignalDisplay from '@/components/SignalDisplay'
import { Popover } from 'element-ui'
import { UserNetworkStats } from '@/types/networkstats'
import './ComputerStats.scss'

export default Vue.extend({
  name: 'ComputerStats',
  props: {
    stats: {
      type: Object as () => UserNetworkStats | undefined
    },
    userIsCaster: {
      type: Boolean,
      default: false
    },
    connected: {
      type: Boolean,
      default: true
    },
    isCasting: {
      type: Boolean,
      default: false
    },
    showHistory: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showUpload (): boolean {
      return this.isCasting && this.stats !== undefined && this.stats.upload !== undefined
    },
    encoderSummary (): string {
      if (this.stats?.encoder === undefined) {
        return 'Unknown'
      }
      if (this.stats?.encoder.cpu_usage > 80) {
        return 'High CPU Usage'
      }
      return 'Healthy'
    },
    totalBitrate (): number {
      if (!this.stats || !this.stats.encoder) {
        return 0
      }
      const bitrate = this.stats.encoder.video_bitrate + this.stats.encoder.audio_bitrate
      return Math.floor(bitrate / 102.4) / 10
    },
    encoderTooltip (): string {
      if (!this.stats || !this.stats.encoder) {
        return ''
      }
      let toolstring = '<table class="stats-table">'
      toolstring += '<tr><td colspan="2" align="center"><h3>My Computer<h3></td></tr>'
      toolstring += '<tr><td>CPU Usage</td><td>' + Math.round(this.stats.encoder.cpu_usage) + '%</td></tr>'
      toolstring += '<tr><td>Encoder Resolution</td><td>' + this.stats.encoder.width + 'x' + this.stats.encoder.height + '</td></tr>'
      toolstring += '<tr><td>Encoder Bitrate</td><td>' + this.totalBitrate + 'kbps</td></tr>'
      toolstring += '</table>'
      return toolstring
    },
    uploadTooltip (): string {
      if (!this.stats || !this.stats.upload) {
        return ''
      }
      let toolstring = '<table class="stats-table">'
      toolstring += '<tr><td colspan="2" align="center"><h3>Upload Info<h3></td></tr>'
      toolstring += '<tr><td>Network Upload</td><td>' + this.stats.upload.score + '/5</td></tr>'
      toolstring += '<tr><td>Upload Speed</td><td>' + this.uploadSpeed + '</td></tr>'
      toolstring += '<tr><td>Upload Jitter</td><td>' + Math.round(this.stats.upload?.jitter || 0) + 'ms</td></tr>'
      toolstring += '<tr><td>Upload latency</td><td>' + Math.round(this.stats.upload?.latency || 0) + 'ms</td></tr>'
      toolstring += '</table>'
      return toolstring
    },
    downloadTooltip (): string {
      if (!this.stats || !this.stats.download) {
        return ''
      }
      let toolstring = '<table class="stats-table">'
      toolstring += '<tr><td colspan="2" align="center"><h3>Download Info<h3></td></tr>'
      toolstring += '<tr><td>Network Download</td><td>' + this.stats.download.score + '/5</td></tr>'
      toolstring += '<tr><td>Download Speed</td><td>' + this.downloadSpeed + '</td></tr>'
      toolstring += '<tr><td>Download Jitter</td><td>' + Math.round(this.stats.download?.jitter || 0) + 'ms</td></tr>'
      toolstring += '<tr><td>Download latency</td><td>' + Math.round(this.stats.download?.latency || 0) + 'ms</td></tr>'
      toolstring += '</table>'
      return toolstring
    },
    uploadSpeed (): string {
      if (!this.stats || !this.stats.upload) {
        return '0 Mbps'
      }
      const upload = this.stats.upload?.bandwidth || 0
      if (upload < 15) {
        return (Math.round(upload * 10) / 10) + 'Mbps'
      }
      return '> 15Mbps'
    },
    downloadSpeed (): string {
      if (!this.stats || !this.stats.download) {
        return '0 Mbps'
      }
      const download = this.stats.download?.bandwidth || 0
      if (download < 15) {
        return (Math.round(download * 10) / 10) + 'Mbps'
      }
      return '> 15Mbps'
    }
  },
  data: () => ({
    tooltip: 'hey there'
  }),
  components: {
    SignalDisplay,
    'el-popover': Popover
  }
})
